import { createContext, useContext, type HTMLAttributes, type ReactNode } from 'react';
import classnames from 'src/util/classnames';

const TabsContext = createContext<{ activeTab?: string | number }>({});

interface TabContentProps extends HTMLAttributes<HTMLDivElement> {
  activeTab?: string | number;
  children?: ReactNode;
}

export function TabContent({ activeTab, className, children, ...props }: TabContentProps) {
  return (
    <TabsContext.Provider value={{ activeTab }}>
      <div className={classnames('tab-content', className)} {...props}>
        {children}
      </div>
    </TabsContext.Provider>
  );
}

interface TabPaneProps extends HTMLAttributes<HTMLDivElement> {
  tabId?: string | number;
  children?: ReactNode;
}

export function TabPane({ tabId, className, children, ...props }: TabPaneProps) {
  const { activeTab } = useContext(TabsContext);
  const isActive = tabId !== undefined && tabId === activeTab;
  return (
    <div
      className={classnames('tab-pane fade', isActive && 'show active', className)}
      role="tabpanel"
      {...props}
    >
      {children}
    </div>
  );
}
